import { Injectable } from '@angular/core';
import { ConfigBaseFilter, SimpleConfigBaseFilter } from 'gung-list';
import {
  AuthService,
  Product,
  ProductExportActionConfigService,
  ProductExportListConfigService,
  ProductExportService,
  ProductListConfigService,
  ProductService,
  ProductSortService
} from 'gung-standard';
import { PimIsInNewsFilter } from './car-liner-product-list-config.service';

@Injectable({
  providedIn: 'root'
})
export class CarLinerProductExportListConfigService extends ProductExportListConfigService {

}
